// AboutPageNavbar.js
import React from 'react';
import { NavBarDropdown } from './NavBarDropdown'; // Corrected capitalization and import syntax
import './AboutPageNavbar.css';

export function AboutPageNavbar() {

  return (
    <div className="main-page-navbar">
      <div className="navbar-container">
        <div className="right-navbar">
          <NavBarDropdown />
        </div>
      </div>
    </div>
  );
}
